import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from "./components/IndexPage.vue";
import ShopPage from "./components/ShopPage.vue";
import AboutusPage from "./components/AboutusPage.vue";
import ContactusPage from "./components/ContactusPage.vue"
import PartnersPage from "./components/PartnersPzge.vue"
import CartPage from "./components/CartPage.vue"
import CheckoutPage from "./components/CheckoutPage.vue"




Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: IndexPage
    },
    {
      path: '/shop',
      name: 'Shop',
      component: ShopPage
    },
    {
      path: '/about',
      name: 'about',
      component: AboutusPage
    },

    {
      path: '/contact',
      name: 'contact',
      component: ContactusPage
    },


    
    {
      path: '/partners',
      name: 'partners',
      component: PartnersPage
    },
      
    {
      path: '/cart',
      name: 'cart',
      component:CartPage
    },

     {
      path: '/checkout',
      name: 'checkout',
      component:CheckoutPage
    }

  ]
})
